
export type LikeTweet200 = {
  code?: string;
  message?: string;
  success?: boolean;
};
